'use strict';

var bind = require('function-bind');

module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// /home/runner/work/RS-rydges2018-docker/RS-rydges2018-docker/wp-content/themes/indcoll-standalone/node_modules/has/src/index.js
// module id = 194
// module chunks = 0